// main.ts
import '@services/tmi'
import { initRouter, navigate } from "@router/index.ts";

initRouter();

document.addEventListener("click", (event) => {
  if (event.target instanceof HTMLAnchorElement) {
    event.preventDefault();
    const route = event.target.getAttribute("href");
    if (route) {
      navigate(route);
    }
  }
});

